import { render, staticRenderFns } from "./wxyuceReport-inventory.vue?vue&type=template&id=b9dbc5d0"
import script from "./wxyuceReport-inventory.vue?vue&type=script&lang=js"
export * from "./wxyuceReport-inventory.vue?vue&type=script&lang=js"
import style0 from "./wxyuceReport-inventory.vue?vue&type=style&index=0&id=b9dbc5d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports